export default __webpack_public_path__ + "static/media/torii gate.2a1f8f57.svg";